type FileUploadIcon2Props = React.SVGProps<SVGSVGElement> & {
  currentColor?: string;
};

export default function FileUploadIcon2({
  className,
  currentColor,
  ...props
}: FileUploadIcon2Props) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.1875 10.6875V14.625C15.1875 14.7742 15.1282 14.9173 15.0227 15.0227C14.9173 15.1282 14.7742 15.1875 14.625 15.1875H3.375C3.22582 15.1875 3.08274 15.1282 2.97725 15.0227C2.87176 14.9173 2.8125 14.7742 2.8125 14.625V10.6875M6.04688 5.76485L9 2.8125L11.9531 5.76485M9 10.6875V2.81457"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
